import config, { apiEnv } from '@Apis/config.api';
import { featuresSelector } from '@Selectors/shared.selectors';
import { SourceType } from '@innovyze/inno-map';
import {
	FeatureFlagConfig,
	getFeatureFlags,
	getService,
	hasFeatureFlags,
} from '@innovyze/lib_get_service';
import { useAuth0 } from '@innovyze/stylovyze';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';

const resolveFeatureFlags = (
	reduxFeatureFlags: FeatureFlagConfig,
): FeatureFlagConfig =>
	hasFeatureFlags()
		? { ...getFeatureFlags(), ...reduxFeatureFlags }
		: reduxFeatureFlags;

export const useDataServices = (configId: string) => {
	const { token } = useAuth0();
	const reduxFeatureFlags = useSelector(
		featuresSelector,
	) as FeatureFlagConfig;

	const tilesBaseUrl = useMemo(() => {
		const featureFlags = resolveFeatureFlags(reduxFeatureFlags);
		return getService('tiles', config, apiEnv, featureFlags);
	}, [reduxFeatureFlags]);

	return useMemo(
		() => [
			{
				id: `Risk/${configId}`,
				type: SourceType.TILES,
				url: `${tilesBaseUrl}/v1/tile-json/Risk/${configId}`,
				token,
			},
		],
		[configId, tilesBaseUrl, token],
	);
};
